import * as types from '../../../actions';

const initialState = {
  certificateDetails: [],
  status:0,
  activity:'',
  errorData:'',    
  totalPage:0,
  numRows:0,
  count:'',
  clientProfileTabActive:'',
  crewProfileTabActive:'',
  expiringCertificateTitle:''
};

export default function(state = initialState, action) {
  const response = action.response;
  let timeVar = '~~'+Date.now(); 
  switch(action.type) {
        case types.CERTIFICATES_LIST_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    certificateDetails: response.data.results,
                    status: response.status,
                    activity:types.CERTIFICATES_LIST_SUCCESS+timeVar
                };
            }else{
                return {
                    ...state,
                    activity:types.CERTIFICATES_LIST_ERROR+timeVar,
                    status: response.status,
                    errorData: response && response.data ? response.data : []                                
                };
            }            
        case types.CERTIFICATES_LIST_ERROR:
            return {
                ...state,
                activity:types.CERTIFICATES_LIST_ERROR+timeVar,
                status: response.status,
                errorData: response && response.data ? response.data : []                                
            };
        
        case types.CLIENT_PROFILE_TAB_ACTIVE: 
            return {
                ...state,
                clientProfileTabActive:action.data
            };
        case types.CLIENT_PROFILE_TAB_DEACTIVE: 
            return {
                ...state,
                clientProfileTabActive:action.data 
            };
        
        case types.CREW_PROFILE_TAB_ACTIVE: 
            return {
                ...state,
                crewProfileTabActive:action.data
            };
        case types.CREW_PROFILE_TAB_DEACTIVE: 
            return {
                ...state,
                crewtProfileTabActive:action.data 
            };
        case types.EXPIRING_CERTIFICATE_TITLE: 
            return {
                ...state,
                expiringCertificateTitle:action.data 
            };

        case types.CLEAR:
            return {
                ...state,
                certificates:[],
                activity:'',
                status:0               
            }  

        default:
            return state;
  }
};